"use strict";
var MatchedUrl = (function () {
    function MatchedUrl(urlPath, urlParams, allParams, auxiliary, rest) {
        this.urlPath = urlPath;
        this.urlParams = urlParams;
        this.allParams = allParams;
        this.auxiliary = auxiliary;
        this.rest = rest;
    }
    return MatchedUrl;
}());
exports.MatchedUrl = MatchedUrl;
var GeneratedUrl = (function () {
    function GeneratedUrl(urlPath, urlParams) {
        this.urlPath = urlPath;
        this.urlParams = urlParams;
    }
    return GeneratedUrl;
}());
exports.GeneratedUrl = GeneratedUrl;
//# sourceMappingURL=route_path.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/router-deprecated/src/rules/route_paths/route_path.js
 ** module id = 373
 ** module chunks = 3
 **/